<template>
    <ValidationObserver
        class="needs-validation form-custom-format"
        v-bind:class="{'was-validated': validated}"
        tag="form"
        ref="observer"
        v-slot="{passes}"
        @submit.prevent="onSubmitForm('without')"
    >
        <el-dialog
            :modal="true"
            ref="window"
            :fullscreen="true"
            :title="'Print Catalog'"
            :visible.sync="syncModal"
            :close-on-click-modal="false"
            :modal-append-to-body="true"
            :append-to-body="true"
            class="text-left bulk-update-qty-dialog"
            :formStatus="formStatus"
            @dialog-state="dialogState"
            :group="group"
            :showClose="!processing"
        >

            
            <ThatsInput :showLabel="false" tabindex="2" fieldClass="col-sm-12" label="" placeholder="Catalog Name" vid="namex" name="namex" v-model="catalogName" :validated="false" :rules="''" size="sm"/>

            <div ref="spreadsheet"></div>
            <template #footer>
                <div class="d-flex">
                    <template v-if="formLoading">
                        <mdb-btn color="elegant" size="sm" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </mdb-btn>
                    </template>
                    <template v-else>
                        <template v-if="formStatus == 'create'">
                            <template v-if="processing == true">
                                <mdb-btn color="elegant" size="sm" disabled>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Processing...
                                </mdb-btn>
                            </template>
                            <template v-else>
                                <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm('without'))" :disabled="processing">
                                    <i class="el-icon-check text-white cursor-pointer"></i> Generate w/o Price
                                </mdb-btn>

                                <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm('with'))" :disabled="processing">
                                    <i class="el-icon-check text-white cursor-pointer"></i> Generate w/ Price
                                </mdb-btn>
                            </template>
                            <mdb-btn color="grey" size="sm" @click="passes(clearForm)">
                                <i class="el-icon-copy-document text-white cursor-pointer"></i> Clear
                            </mdb-btn>
                        </template>
                        <mdb-btn color="grey" size="sm" @click="closeDialog">
                            <i class="el-icon-close text-white cursor-pointer"></i> Close
                        </mdb-btn>
                    </template>
                </div>
            </template>
        </el-dialog>
    </ValidationObserver>
</template>
<script>
import { mdbBtn} from "mdbvue";

import {ValidationObserver} from "vee-validate";
import { mapActions,mapGetters, mapMutations } from 'vuex'

import {  mdbRow,mdbCol } from 'mdbvue';
import jspreadsheet from '../../jsexcel/jexcel'
import { drop } from "lodash";

import { MessageBox, Message } from "element-ui";

import  {ThatsDialog, ThatsInput} from '../../components/thats/Thats'

export default {
    components: { 
        mdbBtn,
        ValidationObserver,
        mdbRow,
        mdbCol,
        ThatsDialog,
        ThatsInput
    },
    props : {
        group : {
            type : Number,
            default : 1
        },
    },

    data(){

    const self = this;
    return {
        formStatus : 'create',
        syncModal : false,
        validated: false,
        form : null,
        formData:null,
        formDataOrginal : null,
        formLoading : false,
        processing : false,
        showError : false,
        group2 : 3,
        spreadsheet: null,
        catalogName: null,
        exportTableOptions : {
            download : false,
            allowDeleteColumn : false,
            allowRenameColumn : false,
            defaultColAlign : 'left',
            csvHeader:true,
            tableWidth : '100%',
            tableHeight : 'calc(100vh - 125px)',
            tableOverflow : true,
            data:[[]],
            minDimensions:[3,50],
            onCopy : null,
            selectionCopy : false,
            allowCopy : true,
            columns: [],
            contextMenu: function(obj, x, y, e) {
                return false;
            },
            onchange: function (domElement, domElmentCell, column, row, value, oldValue) {
                if (column == 0) {
             
                    if ((value != null && value != '' && value != oldValue) || (oldValue == '' && oldValue == null)) {
                        self.fnGetItem(value,row, column)
                    }
                }

            },
        },

        isIndeterminate: false,
        checkAll: true,

        postedData : [],
        }
    },
    inject : ['brandProvider','categoryProvider','areaProvider','collectionProvider'],
    created(){
        this.formData = JSON.parse(JSON.stringify(this.formObject))
        this.formDataOrginal = JSON.parse(JSON.stringify(this.formObject))
    },
    mounted() {

    },
    methods: {
        ...mapActions('ItemModule',['fetchItem']),
        ...mapActions('InventoryItemMasterModule',['storeCatalog']),
        createPopupTable(exportTableOptions){
            this.spreadsheet = jspreadsheet(this.$refs.spreadsheet, exportTableOptions);
            Object.assign(this, this.spreadsheet);
            this.spreadsheet.setData([])
        },

        async recreateSpreadsheet(){
            await this.spreadsheet.destroy();
        },


        optionsHandler(){
            var self = this;
        },

async fnGetItem(itemCode, index, col){
        const self = this;
        await this.fetchItem({item : itemCode, index : index}).then((res)=> {

            if(col == 0){

                // self.spreadsheet.setValueFromCoords(0,index,res.itemCode,true)
                self.spreadsheet.setValueFromCoords(1,index,res.name,true)
                self.spreadsheet.setValueFromCoords(2,index,res.dimension,true)
                self.spreadsheet.setValueFromCoords(3,index,"",true)
                self.spreadsheet.setValueFromCoords(4,index,"",true)
                self.spreadsheet.setValueFromCoords(5,index,res.sale_price,true)
                self.spreadsheet.setValueFromCoords(6,index,"",true)
                self.spreadsheet.setValueFromCoords(7,index,"",true)
                self.spreadsheet.setValueFromCoords(8,index,"",true)
                self.spreadsheet.setValueFromCoords(9,index,"Item found",true)
                self.spreadsheet.setValueFromCoords(10,index,res.id)
            
            }
            
 const parseIntIndex = parseInt(index)

            const backgroundColor = 'transparent'
            self.spreadsheet.setStyle(`A${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`B${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`C${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`D${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`E${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`F${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`G${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`H${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`I${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`J${parseIntIndex+1}`, 'background-color', backgroundColor)
        }).catch((error) => {
            console.log("error")
            console.log(error)
          const parseIntIndex = parseInt(index)
          let backgroundColor = 'rgb(255 200 200)';
          if(( parseIntIndex % 2) == 1){
            backgroundColor = 'rgb(233 167 167)';
          }
            self.spreadsheet.setStyle(`A${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`B${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`C${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`D${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`E${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`F${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`G${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`H${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`I${parseIntIndex+1}`, 'background-color', backgroundColor)
            self.spreadsheet.setStyle(`J${parseIntIndex+1}`, 'background-color', backgroundColor)
        })
    },

        /* end */

        openDialog(){
            this.syncModal = true
            this.formResetter();
            this.formStatus = 'select'
            /* */
        },
        closeDialog(){
            this.syncModal = false
            this.formResetter();
        },
        onSubmitSelectForm() {
            const self = this;

            this.formResetter();

            this.formStatus = 'create';

            const finalColumns = [
                { type: 'text', width: '200px', title: 'Item Code', name: 'series', readOnly: false, primaryKey: false },
                { type: 'text', width: '200px', title: 'Item Name', name: 'name', readOnly: true, primaryKey: false },
                { type: 'text', width: '200px', title: 'Dimension', name: 'dimension', readOnly: false, primaryKey: false },
                { type: 'text', width: '200px', title: 'Category', name: 'category_name', readOnly: false, primaryKey: false },
                { type: 'text', width: '200px', title: 'Brand', name: 'brand_name', readOnly: false, primaryKey: false },
                { type: 'text', width: '200px', title: 'Price', name: 'price', readOnly: false, primaryKey: false },
                { type: 'text', width: '200px', title: 'Promo Price', name: 'promo_price', readOnly: false, primaryKey: false },
                { type: 'text', width: '200px', title: 'Available', name: 'stock', readOnly: false, primaryKey: false },
                { type: 'text', width: '200px', title: 'Percent', name: 'percent', readOnly: false, primaryKey: false },
                { type: 'text', width: '340px', title: 'Response', name: 'message', readOnly: true, primaryKey: false },
                { type: 'hidden', name: 'item_id' },

            ];

         

            this.$nextTick(() => {
                const width = this.$refs.window.width;
                this.exportTableOptions.tableWidth = "100%";
                this.exportTableOptions.columns = finalColumns;
                this.createPopupTable(this.exportTableOptions);
            });
        },

        onSubmitBack(){
            const self = this;
            MessageBox.confirm('Are you sure you want to go back?', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning'
            }).then(() => {

                self.formStatus = 'select';
                self.form = self.formVar()
                requestAnimationFrame(() => {
                    self.$refs.observer.reset();
                });
                self.validated = false
                self.formLoading = false
                if(self.spreadsheet){
                    self.spreadsheet.destroy();
                }

            }).catch(() => {
                return
            });
        },

        onSubmitForm(type) {
            const self = this;

            if (this.processing) {
                return false;
            }

            const tableData = this.spreadsheet.getJson();

            MessageBox.confirm('Warning: Are you sure you want to submit the data?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                if (tableData.length > 0) {
                    this.postCounter = 0;
                    this.dataLength = tableData.filter(item => item.series !== '').length;

                    if (this.dataLength > 0) {
                        const validData = tableData.filter(item => item.series !== '').map(item => {
                            return { ...item, completed: false };
                        });

                        if (validData.length === 0) {
                            self.$ThatsNotify.warning({
                                message: `Please fill up the series column.`,
                                timeOut: 10000
                            });
                            return false;
                        }

                        console.log('dataLength', validData);
                       
                        self.postedData = JSON.parse(JSON.stringify(validData));

                        let chain = Promise.resolve();

                        const items = [];

                        validData.forEach((element) => {
                            function mapElementToFormData(element) {
                                return {
                                    item_id: element.item_id,
                                    dimension: element.dimension,
                                    color: element.color,
                                    price: element.price,
                                    promo_price: element.promo_price,
                                    category_name: element.category_name,
                                    brand_name: element.brand_name,
                                    stock: element.stock,
                                    percent : element.percent,
                                }
                            }

                            const mappedData = mapElementToFormData(element);
                            console.log("mappedData",mappedData)
                            chain = chain.then(() => {
                                items.push(mappedData)
                            });
                        });

                        chain.finally(() => {
                            // console.log('All records processed.',items);


                            self.storeCatalog({
                                items : items,
                                name : self.catalogName
                            }).then((res) => {
                                console.log("response",res)
                                const url = `/carpet-index?type=${type}&id=${res.data.id}`
                                const win = window.open(url, "_blank");
                                win.document.title = 'Print';
                                self.processing = false;
                            }).catch((err) => {
                                console.log("error",err)
                                self.processing = false;
                            })
                           /*  const itemIds = itemId.toString(); */
                            /* var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";
                            const win = window.open(`/carpet-index?items=${itemIds}`, "_blank", strWindowFeatures);
                            win.document.title = 'Print'; */

                            /* const win = window.open(`/carpet-index?items=${itemIds}&title=${this.catalogName}`, "_blank");
                            win.document.title = 'Print';
                            // win.print()

                             */
                        });
                    }
                }
            }).catch(() => {
                // Handle the case where the user cancels the confirmation dialog
                console.log('Confirmation dialog was cancelled.');
            });
        },


        formResetter(){
            this.form = this.formVar()
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
            this.validated = false
            this.formLoading = false
            this.processing = false
            this.setFormStatusCreate();

            if(this.spreadsheet){
                this.spreadsheet.destroy();
            }
        },

        dialogState(state){
            this.optionsHandler();
            if(!state){
                this.formResetter();
                return
            }
            if(this.FormStatus == 'create'){
                this.formResetter();
            }

        },

        formVar(){
            return {
                items : [],
            }
        },
        setFormStatusCreate(){
            this.formStatus = 'create'
        },

        iterateAlphabetByNumber(numColumns) {
            const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const columns = [];

            for (let i = 0; i < numColumns; i++) {
                let label = '';
                let index = i;
                while (index >= 0) {
                    label = alphabet[index % 26] + label;
                    index = Math.floor(index / 26) - 1;
                }

                columns.push(label);
            }
            return columns;
        },
        clearForm(){
            this.recreateSpreadsheet();
            this.createPopupTable(this.exportTableOptions);
        },
    },

    computed: {
        ...mapGetters('InventoryItemMasterModule',{
            formRecord : 'formData',
            viewLoading : 'getLoading',
            postLoading : 'postLoading',
            formObject : 'initialFormObject',
        }),

   

        brandComputed : function(){
            return [];
        },
        groupComputed : function(){
            return [];
        },

        categoryComputed : function(){
            return [];
        },
        areaComputed : function(){
            return [];
        },

        collectionComputed : function(){
            return [];
        },

        enableButton : function(){
            return (this.areaComputed.length > 0 && this.brandComputed.length > 0 && this.categoryComputed.length > 0) ? false : true;
        },

        isAllCompleted : function(){
            return (this.postedData.length > 0) ? this.postedData.every((item) => item.completed == true) : false;
        }
    },

    watch: {

        brandComputed : function(v){
            this.filteredBrands = v
        },
        syncModal(val) {
            if (val && this.formStatus === 'select') {
                this.onSubmitSelectForm();
            }
        },
        isAllCompleted : function(value){
            if(value == true){
                this.processing = false;
                this.$emit('success');
            }
        }
    },


}
</script>

<style scoped>
.custom-checkbox .custom-control-label::before {
    border-radius: .50rem!important;cursor: pointer;
}

.no-image-gallery i.far {
    font-size: 42px;
    color: #959595;
}
.mdb-time-picker .clockpicker-span-hours,
.mdb-time-picker .clockpicker-span-minutes {
    color: #4285f4 !important;
}


</style>
